import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container } from "@material-ui/core";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DateTile from "../DateTile/DateTile";
import Box from '@material-ui/core/Box';
import ScheduleDatePicker from "../../screens/GameSchedule/ScheduleDatePicker";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexWrap: "nowrap",
    },
    calenderSlider: {
        height: theme.spacing(20.5),
        marginBottom: theme.spacing(2),
        position: 'relative',
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(0, 3.5),
        },
        "& .slick-slider": {
            height: "100%",
        },
    },
    //headerBox: {
    //    display: 'flex',
    //    alignItems: 'center',
    //    justifyContent: 'space-between',
    //    paddingLeft: theme.spacing(0),
    //    paddingRight: theme.spacing(0),
    //    paddingBottom: theme.spacing(0),
    //    paddingTop: theme.spacing(0),
    //},
    icon: {
        fontSize: '1.5rem',
        color: "#f7f7f7",
    },
}));

function SliderCalendar(props) {
    const classes = useStyles();
    const sliderRef = useRef(null);

    // Effect hook to monitor sessionStorage changes via props.ActiveState update
    useEffect(() => {
        // 1. Retrieve the index string from sessionStorage
        const savedIndexStr = sessionStorage.getItem("activeTile");

        if (savedIndexStr !== null && sliderRef.current) {
            // 2. Parse string into an integer base 10
            const targetIndex = parseInt(savedIndexStr, 10);

            // 3. Programmatically scroll to the active position
            if (!isNaN(targetIndex)) {
                sliderRef.current.slickGoTo(targetIndex);
            }
        }
    }, [props.ActiveState]); // Fires whenever the active/highlight array state updates

    const settings = {
        infinite: props.isFilterApply ? true : false,
        // slower transition for smoother UX
        speed: 2400,
        cssEase: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        slidesToShow: 11,
        // ensure slidesToScroll equals slidesToShow for page-like movement
        slidesToScroll: 11,
        swipeToSlide: false,
        draggable: true,
        touchThreshold: 10,
        lazyLoad: 'ondemand',
        initialSlide: props.intialTiles,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 11,
                    slidesToScroll: 11,
                    infinite: props.isFilterApply ? true : false,
                    initialSlide: props.intialTiles,
                    centerMode: false,
                    speed: 2400,
                },
            },
            {
                breakpoint: 1198,
                settings: {
                    slidesToShow: 9,
                    slidesToScroll: 9,
                    infinite: props.isFilterApply ? true : false,
                    initialSlide: props.intialTiles,
                    centerMode: false,
                    speed: 2400,
                },
            },
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 9,
                    slidesToScroll: 9,
                    infinite: props.isFilterApply ? true : false,
                    initialSlide: props.intialTiles,
                    centerMode: false,
                    speed: 2400,
                },
            },
            {
                breakpoint: 993,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 7,
                    infinite: props.isFilterApply ? true : false,
                    initialSlide: props.intialTiles,
                    centerMode: false,
                    speed: 2400,
                },
            },
            {
                breakpoint: 823,
                settings: {
                    infinite: props.isFilterApply ? true : false,
                    slidesToShow: 7,
                    slidesToScroll: 7,
                    initialSlide: props.intialTiles,
                    centerMode: false,
                    speed: 1000,
                },
            },
            {
                breakpoint: 812,
                settings: {
                    infinite: props.isFilterApply ? true : false,
                    slidesToShow: 7,
                    slidesToScroll: 7,
                    initialSlide: props.intialTiles,
                    centerMode: false,
                    speed: 1000,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    infinite: props.isFilterApply ? true : false,
                    slidesToShow: 6,
                    slidesToScroll: 6,
                    initialSlide: props.intialTiles,
                    centerMode: false,
                    speed: 1000,
                },
            },
            {
                breakpoint: 720,
                settings: {
                    infinite: props.isFilterApply ? true : false,
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    initialSlide: props.intialTiles,
                    centerMode: false,
                    speed: 1000,
                },
            },
            {
                breakpoint: 667,
                settings: {
                    infinite: props.isFilterApply ? true : false,
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    initialSlide: props.intialTiles,
                    centerMode: false,
                    speed: 1000,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    infinite: props.isFilterApply ? true : false,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    initialSlide: props.intialTiles,
                    centerMode: false,
                    speed: 1000,
                },
            },
            {
                breakpoint: 568,
                settings: {
                    infinite: props.isFilterApply ? true : false,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    initialSlide: props.intialTiles,
                    centerMode: false,
                    speed: 1000,
                },
            },
            {
                breakpoint: 540,
                settings: {
                    infinite: props.isFilterApply ? true : false,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    initialSlide: props.intialTiles,
                    centerMode: false,
                    speed: 1000,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    infinite: props.isFilterApply ? true : false,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    initialSlide: props.intialTiles,
                    centerMode: false,
                    speed: 1000,
                },
            },
        ],
    };

    return (<>
        {props.tilesDates !== undefined && props.tilesDates.length > 0 &&
            <Container className={classes.calenderSlider} key={`xy${props.forceKey}z`}>
                <ScheduleDatePicker
                    side="left"
                    handleDateSelection={props.handleDateSelection}
                    selectedDate={props.selectedDate}
                    calenderDates={props.calenderDates}
                />
                <Slider ref={sliderRef} {...settings}>
                    {props.tilesDates.map((item, index) => {
                        return (
                            <div key={item.gameDate}>
                                <DateTile
                                    data={item}
                                    onClick={(data) => {
                                        props.populateGames(item.gameDate, index);
                                    }}
                                    isActive={
                                        props.ActiveState !== undefined &&
                                            props.ActiveState.length > 0
                                            ? props.ActiveState[index]
                                            : null
                                    }
                                />
                            </div>
                        );
                    })}
                </Slider>
                <ScheduleDatePicker
                    side="right"
                    handleDateSelection={props.handleDateSelection}
                    selectedDate={props.selectedDate}
                    calenderDates={props.calenderDates}
                />
            </Container>
        }
    </>)
}
export default SliderCalendar;
